import { useCallback } from 'react';
import { useApiGestao } from 'servicos/api-gestao/base';

export function useGetEmpresa() {
  const { invocarApi, ...outrasPropriedades } = useApiGestao();

  const getEmpresa = useCallback(
    (id) =>
      invocarApi({
        url: `empresa/` + id,
        enviarTokenUsuario: true
      }),
    [invocarApi],
  );

  const getEmpresas = useCallback(
    () =>
      invocarApi({
        url: `empresa`,
        enviarTokenUsuario: true
      }),
    [invocarApi],
  );

  return {
    ...outrasPropriedades,
    getEmpresa,
    getEmpresas
  };
}
